<template>
  <div class="positionfixed3">
    <div class="DeepDesign">
      <div class="DeepDesign_content">
        <!-- 动态设置 iframe 的 src 地址 -->
        <iframe
            :src="iframeSrc"
            width="100%"
            height="100%"
            frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeSrc: '', // iframe 的动态 URL
    };
  },
  mounted() {
    // 获取 token 和 tempId，并更新 iframe 的 src 地址
    const token = localStorage.getItem('token');
    const tempId = this.$route.query.tempId; // 从路由参数中获取 tempId
    console.log('token:', token, 'tempId:', tempId);

    if (token && tempId) {
      this.iframeSrc = `https://editor.ai-dog.net/#/?token=${token}&tempId=${tempId}`;
    } else {
      console.warn('缺少 token 或 tempId，无法生成 iframeSrc');
    }
    // 注册message接收消息
    window.addEventListener("message",(res) => {
      console.log("回调", res?.data)
      if (res?.data) {
        switch (res?.data?.type) {
          case 'jump':
            this.$router.push(res?.data?.path).then()
        }
      }
    })
  },
};
</script>

<style>
.DeepDesign {
  background: #e4edf6;
}
.DeepDesign_content {
  height: 100vh; /* 确保 iframe 占满视口高度 */
}
</style>
